import React from 'react';
import { QueryBuilder } from 'react-querybuilder';
import type { Field, RuleGroupType } from 'react-querybuilder';
import { Box } from '@mantine/core';
import 'react-querybuilder/dist/query-builder.css';
import { MantineQueryBuilderComponents } from './components';
import { SUPPORTED_OPERATORS, SUPPORTED_COMBINATORS } from './operators';

interface CustomQueryBuilderProps {
  fields: Field[];
  query: RuleGroupType;
  onQueryChange: (query: RuleGroupType) => void;
  addRuleToNewGroups?: boolean;
  autoSelectField?: boolean;
  autoSelectOperator?: boolean;
  showCombinatorsBetweenRules?: boolean;
  showNotToggle?: boolean;
  showCloneButtons?: boolean;
  resetOnFieldChange?: boolean;
  resetOnOperatorChange?: boolean;
}

export const CustomQueryBuilder: React.FC<CustomQueryBuilderProps> = ({
  fields,
  query,
  onQueryChange,
  ...props
}) => {
  return (
    <Box
      sx={(theme) => ({
        '.ruleGroup': {
          backgroundColor: 'transparent',
          border: 'none',
          padding: 0,
        },
        // The header row holds the combinator selector + add buttons.
        '.ruleGroup-header': {
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing.xs,
          marginBottom: theme.spacing.xs,
        },
        // Each rule row: give the controls breathing room and vertical rhythm.
        '.ruleGroup .rule': {
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing.xs,
          padding: `${theme.spacing.xs}px 0`,
        },
        // Constrain the selectors and let the value editor take the remaining space.
        '.ruleGroup-combinators': { width: 84, flex: '0 0 auto' },
        '.rule-fields': { width: 170, flex: '0 0 auto' },
        '.rule-operators': { width: 180, flex: '0 0 auto' },
        '.rule-value': {
          flex: 1,
          minWidth: 120,
        },
        // Branch connector color to match the indigo theme.
        '.queryBuilder-branches .rule::before, .queryBuilder-branches .rule::after, .queryBuilder-branches .ruleGroup .ruleGroup::before, .queryBuilder-branches .ruleGroup .ruleGroup::after':
          {
            borderColor: theme.colors.indigo[5],
          },
      })}
    >
      <QueryBuilder<RuleGroupType>
        fields={fields}
        query={query}
        onQueryChange={onQueryChange}
        operators={SUPPORTED_OPERATORS}
        combinators={SUPPORTED_COMBINATORS}
        controlElements={MantineQueryBuilderComponents}
        controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
        {...props}
      />
    </Box>
  );
};
